import React, { useState } from "react";
import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const { name, email, phone, message } = formData;

        const subject = encodeURIComponent("Enquiry from Website");
        const body = encodeURIComponent(
            `Full Name: ${name}\nEmail: ${email}\nPhone Number: ${phone}\n\nMessage:\n${message}`
        );

        const mailtoLink = `mailto:fatix.faham@yahoo.com?subject=${subject}&body=${body}`;
        window.location.href = mailtoLink;
    };

    return (
        <div className="relative">
            <Navbar />
            <div className="container mx-auto py-[70px]">
                <div className="flex flex-col lg:flex-row justify-between gap-[10%]">
                    {/* Contact Form Section */}
                    <div className="w-full lg:w-1/2">
                        <h2 className="text-3xl font-bold mb-4 contact-us-heading-text">Contact Us</h2>
                        <p className="text-gray-600 mb-6 contact-us-heading-subtext">
                            Have questions or ready to explore our services? Feel free
                            to reach out for more information — and contact us as well to join our wholesale service.
                        </p>
                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <input
                                type="text"
                                name="name"
                                placeholder="Full Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                            />
                            <input
                                type="text"
                                name="phone"
                                placeholder="Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                            />
                            <textarea
                                name="message"
                                placeholder="Enquiry"
                                rows="5"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                            ></textarea>
                            <button
                                type="submit"
                                className="w-full text-white py-3 rounded-md transition fatix-send-form-btn"
                            >
                                Send Enquiry
                            </button>
                        </form>
                    </div>

                    {/* Contact Info Section */}
                    <div className="w-full lg:w-1/2 call-us-fatix-divv">
                        <h2 className="text-3xl font-bold mb-4 fatix-call-us-contact">Call Us</h2>
                        <p className="text-gray-600 mb-[30px]">
                            <a href="tel:2349036410169">+234 903 641 0169</a>
                        </p>

                        <h2 className="text-3xl font-bold mb-4 fatix-call-us-contact">Email Us</h2>
                        <p className="text-gray-600 mb-[30px]">
                            <a href="mailto:fatix.faham@yahoo.com">fatix.faham@yahoo.com</a>
                        </p>

                        <h2 className="text-3xl font-bold mb-4 fatix-call-us-contact">Visit Us</h2>
                        <p className="text-gray-600">
                            <b>Head office:</b> 22 Banjoko Street, Oshodi, Lagos<br />
                            <b>Branch Office:</b> 433 Agege Motor Road, Bolade Oshodi, Lagos<br />
                            <b>Ibadan Branch:</b> Last Gate, Old Generator House, New Gbagi Market, Ibadan, Oyo State
                        </p>
                    </div>
                </div>
            </div>
            <a
                href="https://wa.me/2349036410169"
                className="fixed bottom-4 right-4 z-50"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="Chat on WhatsApp"
                    className="w-24 h-24 hover:scale-105 transition-transform duration-200"
                />
            </a>
            <Footer />
        </div>
    );
};

export default Contact;
